import React from 'react';

import { BaseIconProps } from './';

export const Envelope = ({ fill }: BaseIconProps) => (
  <path
    transform="matrix(2.109375,0,0,-2.109375,0,1080)"
    d="m 48,108 v 191 c 23,-19 55,-45 105,-85 22,-18 60,-57 103,-56 43,-1 81,38 103,56 35,28 70,56 105,85 V 108 Z M 464,404 V 362 C 442,343 406,314 329,253 313,239 279,206 256,207 233,206 199,239 183,253 106,314 70,343 48,362 v 42 z m 0,49 H 48 C 21,453 0,431 0,404 V 108 C 0,81 21,59 48,59 h 416 c 26,0 48,22 48,49 v 296 c 0,27 -22,49 -48,49 z"
    fill={fill}
  />
);
